"use client";

import Button from "@/components/ui/Button";
import { RenewCookieButtonStoryblok } from "@/generated/sb/sb-types";
import type { BlokProps } from "@frend-digital/storyblok";

export const RenewCookieButtonBlok = ({
  blok,
}: BlokProps<RenewCookieButtonStoryblok>) => {
  function renew() {
    try {
      const _hsp = (window._hsp = window._hsp || []);
      _hsp.push(["showBanner"]);
    } catch (e) {
      console.log(e);
    }
  }
  return (
    <Button id="hs_show_banner_button" mode="link" onClick={renew}>
      {blok.text}
    </Button>
  );
};

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _hsp: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _hsq: any;
  }
}
